import React, { useEffect, useRef } from 'react'
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ValidationText from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';
import ShowItemContent from './ShowItemContent';

const SimpleQuestion = ({ item, setItem, validations, activeAccordion, isGroupNote, ...props }) => {
  // let activeAccordion = 'Intake Form';
  console.log("validationItemsModal SimpleQuestion", validations);
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  const showContent = (item) => {
    if (item.IsRepeated === 'true') {
      return item.PatientName + ' - ' + item.content || '[Enter prompt or question]'
    } else {
      return item.content || '[Enter prompt or question]'
    }
  }

  const textareaRef = useRef(null);

  const autoResize = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.setProperty("height", "100px", "important");
    el.style.setProperty(
      "height",
      `${Math.max(100, el.scrollHeight)}px`,
      "important"
    );
  };
  useEffect(() => {
    autoResize();
  }, [item.answer]);
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>

      <div className='content-box d-flex flex-column gap-6 w-100'>
        <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
          {/* {item.content || '[Enter prompt or question]'} */}
          {ShowItemContent(item, isGroupNote)}
          {/* \\ Required icon commented \\ */}
          {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
        </p>
        {item.MultiLineAnswer === "true" ?
          <div className={`input w-100  ${validations?.isInvalid ? 'error' : ''}`}>
            <textarea
              ref={textareaRef}
              className="form-control overflow-hidden"
              rows={4}
              value={item.answer}
              onChange={(e) => handleSetAnswer(e, item)}
            />
            <ValidationText name={item.name} />
          </div>
          :

          <div className={`input mb-0 w-100  ${validations?.isInvalid ? 'error' : ''}`}>
            <input
              type="text"
              className="form-control"
              value={item.answer}
              onChange={(e) => handleSetAnswer(e, item)}
            />
            <ValidationText name={item.name} />
          </div>
        }
      </div>
    </div>

  )
}

export default SimpleQuestion